// extracted by mini-css-extract-plugin
module.exports = {"title":"pages_title__33UGu"};